<div class="row g-0 myfit content-margin">
  @switch (ticket.terminationStatus) {
  @case (TicketTerminationStatusASM.IN_PROGRESS){
      <div class="col ">
        <div class="termination termination-status row-item"
             data-cy="ticket-termination-status-proposed"
             [ngStyle]="{'color': getTicketTerminationStatusColor(ticket?.terminationStatus)}">
          <span class="icon-container"><fa-icon [icon]="faTicketXmark"></fa-icon></span>
          {{ ('TICKETS.TERMINATION_STATUS.'+ticket?.terminationStatus)|translate}}
        </div>
        <div class="termination termination-reason row-item">
          <span class="icon-container"><fa-icon [icon]="faSign"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.REASON' | translate }}: {{ ticket.terminationReason }}
        </div>
        <div class="termination termination-date row-item">
          <span class="icon-container"><fa-icon [icon]="faBan"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATED_AT' | translate }} {{ ticket.terminationCreatedAt | date:'dd.MM.yyyy' }}
        </div>
        <div class="termination termination-date row-item">
          <span class="icon-container"><fa-icon [icon]="faClock"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATION_DATE' | translate }} {{ ticket.terminationDate | date:'dd.MM.yyyy' }}
        </div>
      </div>
           <div class="col col-6  align-items-center">
              <div class="button-container">
              @if(ticket?.terminationTransferredAt || ticket?.proposedBy!==benutzerSessionService.getCurrentBenutzerUserId()  || ticket?.terminationSystemGenerated){
              <div class="termination-hint" data-cy="info-unable-to-cancel">
                {{'TICKETS.TERMINATION.UNABLE_TO_CANCEL_TERMINATION'|translate}}
              </div>
            }
            @else {
              <button class="btn btn-outline-secondary w-100"
                      (click)="cancelTicketTermination()">
                <div>
                  <span> {{ 'TICKETS.BUTTON_CANCEL' | translate }}</span>
                </div>
              </button>
            }
          </div>
        </div>
  }
  @case (TicketTerminationStatusASM.COMPLETED){
      <div class="col">
        <div class="termination termination-status"
             [ngStyle]="{'color': getTicketTerminationStatusColor(ticket?.terminationStatus)}">
          <span class="icon-container"><fa-icon [icon]="faTicketXmark"></fa-icon></span>
          {{ ('TICKETS.TERMINATION_STATUS.'+ticket?.terminationStatus)|translate}}
        </div>
        <div class="termination termination-date">
          <span class="icon-container"><fa-icon [icon]="faBan"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATED_AT' | translate }} {{ ticket.terminationCreatedAt | date:'dd.MM.yyyy' }}
        </div>
        <div class="termination termination-date row-item">
          <span class="icon-container"><fa-icon [icon]="faClock"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATION_DATE' | translate }} {{ ticket.terminationDate | date:'dd.MM.yyyy' }}
        </div>
      </div>
  }
  @case (TicketTerminationStatusASM.ABORTED){
      <div class="col">
        <div class="termination termination-status"
             [ngStyle]="{'color': getTicketTerminationStatusColor(ticket?.terminationStatus)}">
          <span class="icon-container"><fa-icon [icon]="faTicketXmark"></fa-icon></span>
          {{ ('TICKETS.TERMINATION_STATUS.'+ticket?.terminationStatus)|translate}}
        </div>
        <div class="termination termination-date row-item">
          <span class="icon-container"><fa-icon [icon]="faBan"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATED_AT' | translate }} {{ ticket.terminationCreatedAt | date:'dd.MM.yyyy' }}
        </div>
        <div class="termination termination-date row-item">
          <span class="icon-container"><fa-icon [icon]="faClock"></fa-icon></span>
          {{ 'TICKETS.TERMINATION.TERMINATION_DATE' | translate }} {{ ticket.terminationDate | date:'dd.MM.yyyy' }}
        </div>
      </div>
      <div class="col col-6">
        <div class="button-container">
        @if(ticket.status === TicketStatusASM.ACTIVE) {
          <button class=" btn btn-outline-primary w-100"
                  (click)="terminateTicket()" >
            <div>
              <div style="display: flex; flex-direction: column; align-items: center;">
                <span> {{ 'TICKETS.BUTTON_TERMINATE' | translate }}</span>
              </div>
            </div>
          </button>
        }
        @else {
          <div class="termination-hint">
          {{'TICKETS.TERMINATION.UNABLE_TO_TERMINATE' | translate}}
          </div>
        }
        </div>
      </div>
  }
  @default {
      <div class="col termination termination-status termination-none row-item" >
        <span class="icon-container"><fa-icon [icon]="faTicketXmark"></fa-icon></span>
        {{ 'TICKETS.TERMINATION_STATUS.NONE' | translate }}
      </div>
      <div class="col col-6" >
        <div class="button-container">
        @if(ticket.status === TicketStatusASM.ACTIVE) {
          <button class=" btn btn-outline-primary w-100"
                  (click)="terminateTicket()" >
            <div>">
                <span> {{ 'TICKETS.BUTTON_TERMINATE' | translate }}</span>
            </div>
          </button>
        }
        @else {
          <div class="termination-hint">
          {{'TICKETS.TERMINATION.UNABLE_TO_TERMINATE' | translate}}
          </div>
        }
        </div>
      </div>
  }
}
</div>
